import React from 'react';
import MathText from '../../VueQuestion/MathText';

// Composant pour un savoir-faire ou attendu
const ContentNode = ({ item, isActive, side, type }) => {
  const isLeft = side === 'left';
  // 'bottom' : liste sous la carte (mobile + mode compact desktop) — pas de
  // connecteur vers le tronc, la carte prend la largeur de sa cellule.
  const isBottom = side === 'bottom';
  const isAttendu = type === 'attendu';

  return (
    <div className={`flex items-center gap-3 ${isLeft ? 'flex-row-reverse' : ''} ${isBottom ? 'w-full' : ''}`}>
      {/* Ligne de connexion (satellites gauche/droite uniquement) */}
      {!isBottom && (
        <div className="relative">
          <div className={`
            w-8 h-0.5
            ${isActive ? 'bg-slate-300' : 'bg-white/20'}
          `} />
          <div className={`
            absolute ${isLeft ? '-left-1' : '-right-1'} top-1/2 -translate-y-1/2
            w-2 h-2 rounded-full
            ${isActive ? 'bg-slate-400' : 'bg-white/30'}
          `} />
        </div>
      )}

      {/* Card */}
      <div className={`
        group relative rounded-xl cursor-pointer transition-all duration-300
        backdrop-blur-md overflow-hidden
        ${isBottom
          ? 'w-full'
          : 'min-w-56 max-w-72 xl:min-w-44 xl:max-w-56 2xl:min-w-48 2xl:max-w-64 3xl:min-w-56 3xl:max-w-72'
        }
        ${isActive
          ? 'bg-white/90 shadow-lg hover:shadow-xl hover:scale-[1.02]'
          : 'bg-white/40'
        }
      `}>
        {/* Badge type en header */}
        <div className={`px-2 py-0.5 text-white text-[8px] font-medium uppercase ${isActive ? 'bg-blue-500/80' : 'bg-blue-500/60'}`}>
          {isAttendu ? 'Attendu' : 'Savoir-faire'}
        </div>
        {/* Nom */}
        <p className={`px-3 xl:px-2 2xl:px-2.5 3xl:px-3 py-2 xl:py-1.5 2xl:py-1.5 3xl:py-2 text-sm xl:text-xs 2xl:text-xs 3xl:text-sm font-medium leading-tight ${isActive ? 'text-slate-700' : 'text-slate-600'}`}>
          <MathText>{item.nom || item.name || item.titre || item.description}</MathText>
        </p>
      </div>
    </div>
  );
};

export default ContentNode;
